module.exports = __webpack_public_path__ + "img/check-mark.f51f3f3a.svg";